<div mat-dialog-content class="dialog-content">
  <div class="header-section">
    <mat-icon color="warn" class="warning-icon">warning</mat-icon>
    <span mat-dialog-title>SyRF Error Detected</span>
  </div>

  <div class="message-section">
    <p class="main-message">
      The error has been reported but the application may be in an unstable
      state.
    </p>

    <app-information-box warning class="risk-list">
      <p class="risk-header">Continuing without refreshing may cause:</p>
      <ul>
        <li>
          <mat-icon class="risk-icon">error_outline</mat-icon> Unexpected
          behavior or broken functionality
        </li>
        <li>
          <mat-icon class="risk-icon">data_loss_prevention</mat-icon> Data loss
          or corruption
        </li>
        <li>
          <mat-icon class="risk-icon">broken_image</mat-icon> UI components not
          working properly
        </li>
        <li><mat-icon class="risk-icon">speed</mat-icon> Performance issues</li>
      </ul>
    </app-information-box>

    <p class="recommendation">
      <strong
        >Refresh the page as soon as possible to restore SyRF to a stable
        state.</strong
      >
    </p>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button
    mat-button
    color="warn"
    (click)="onContinueClick()"
    class="continue-button"
  >
    DON'T REFRESH NOW
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onRefreshClick()"
    class="refresh-button"
  >
    <mat-icon>refresh</mat-icon>
    REFRESH (recommended)
  </button>
</div>
